export default __webpack_public_path__ + "static/media/3.da4dbcb5.png";